import React from 'react';
import { Theme, makeStyles, createStyles } from '@material-ui/core/styles';
import MuiTooltip, { TooltipProps } from '@material-ui/core/Tooltip';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tooltip: (props: { inverted?: boolean }) => ({
      backgroundColor: props.inverted ? theme.palette.common.black : theme.palette.common.white,
      boxShadow: theme.shadows[2],
      color: props.inverted ? theme.palette.common.white : theme.palette.text.primary,
      margin: theme.spacing(0.75),
      maxWidth: '40rem',
      padding: theme.spacing(1, 2),
      fontSize: theme.typography.body1.fontSize,
      fontWeight: theme.typography.body1.fontWeight,
    }),
  }),
);

interface Props {
  title?: any;
  inverted?: boolean;
}

type P = Props & Partial<TooltipProps>;

const Tooltip: React.FC<P> = (props) => {
  const { inverted, ...tooltipProps } = props;
  const classes = useStyles({ inverted });

  return <MuiTooltip title="" children={<p>Tooltip</p>} classes={classes} {...tooltipProps} interactive enterTouchDelay={100} leaveTouchDelay={10000} />;
};

export default React.memo(Tooltip);
